// extracted by mini-css-extract-plugin
export default {"root":"SuggestionChip_root__xL2KQ","icon":"SuggestionChip_icon__rAsKd","label":"SuggestionChip_label__NwJZR","container":"SuggestionChip_container__Q5YAy"};